module.exports = __webpack_public_path__ + "static/media/admin.829c7d89.png";